export class Image {

    url: string;
    width: number;
    height: number;

    static createImage(url: string, width: number, height: number): Image {
        const img = new Image();
        img.url = url;
        img.width = width;
        img.height = height;

        return img;
    }
}
